$(document).ready(function () {
  $(".main-brand--collection").owlCarousel({
    loop: true,
    nav: true,
    autoplayTimeout: 7000,
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1, 
      },
    },
  });
  var mobileCarousel = $("#mobile-carousel");
  var desktopCarousel = $("#desktop-carousel");
  if (desktopCarousel.length > 0) {
    desktopCarousel.on("changed.owl.carousel", function (event) {
      if (event.namespace && event.property.name === "position") {
        var target = event.relatedTarget.relative(event.property.value);
        mobileCarousel.owlCarousel("to", target, 300, true);
      }
    });
  }
  if (mobileCarousel.length > 0) {
    mobileCarousel.on("changed.owl.carousel", function (event) {
      if (event.namespace && event.property.name === "position") {
        var target = event.relatedTarget.relative(event.property.value);
        desktopCarousel.owlCarousel("to", target, 300, true);
      }
    });
  }
  $(".owl-prev").html(`<div class="option-arrow-left">
  <img src="${window._icons.arrowLeft}" alt="">
</div>`);

  $(".owl-next").html(`<div class="option-arrow-right">
  <img src="${window._icons.arrowRight}" alt="">
</div>`);
});

class SectionGalleryPopup extends HTMLElement {
  constructor() {
    super();
    window.onload = () => {
      this.initGallery();
    };
  }
  initGallery() {
    this.closeGalleryBtn = this.querySelector('.section-gallery__owl-popup--close button');
    this.galleryOverlayPopup = this.querySelector('.section-gallery__owl-popup--overlay');
    this.slideItems = document.querySelectorAll('.owl-carousel--simp .owl-item img');
    console.log(this.slideItems);
    if (this.closeGalleryBtn && this.galleryOverlayPopup) {
      this.setupEventListeners();
    } else {
      console.error("Some required elements not found.");
    }
  }
  setupEventListeners() {
    if (this.closeGalleryBtn && this.galleryOverlayPopup) {
      this.closeGalleryBtn.addEventListener('click', () => {
        this.closeMediaGallery();
      });
      this.galleryOverlayPopup.addEventListener('click', () => {
        this.closeMediaGallery();
        console.log("close the drawer", this.galleryOverlayPopup);
      });
    }
    if (this.slideItems) {
      this.slideItems.forEach((ele) => {
        ele.addEventListener('click', (e) => {
          this.openMediaGallery(e.target);
        });
      });
    }
  }
  closeMediaGallery() {
    this.style.display = 'none';
    document.body.style.overflow = '';
  }
  openMediaGallery(e) {
    this.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }
}

customElements.define('section-gallery-popup', SectionGalleryPopup);
